import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/aerobic-gymnastics/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/aerobic-gymnastics',
  name: 'activity_aerobics_gymnastics',
  component: Index,
  meta: {
    title: '巨星养成计划',
    expiryDate: '2024-04-16',
  },
}

export default [indexRoute]
